import type { Action } from '@reduxjs/toolkit'

// Utilities
interface ILoadingIdentification {
  openRequests: string[]
}

export const removeRequestByType = (state: ILoadingIdentification, type: string): string[] => {
  return state.openRequests.filter((requests: string) => requests !== type)
}

/**
 * Clears the request an outcome action settles, from `<name>Success` / `<name>Failure` back to
 * `<name>Request`.
 *
 * Two naming conventions are in use — `fooRequest`/`fooSuccess` and `fooRequest`/`fooRequestSuccess` —
 * and a plain substring swap only handled the first: the second became `fooRequestRequest`, matched
 * nothing, and left the entry in place for good. 34 actions across the project, order, invitation and
 * organization slices are named the second way.
 */
export const removeRequest = (state: ILoadingIdentification, action: Action<string>): string[] => {
  const settled = action.type.replace(/(Success|Failure)$/, '')
  return removeRequestByType(state, settled.endsWith('Request') ? settled : `${settled}Request`)
}

interface IIdentifiable {
  id: string
}

export const removeById = (arr: IIdentifiable[], id: string) => {
  return arr.filter((element) => element.id !== id)
}

export const removeByIds = (arr: IIdentifiable[], ids: string[]) => {
  return arr.filter((element) => !ids.find((id) => id === element.id))
}
